module.exports = __webpack_public_path__ + "img/logo-exclusion.19d82bdf.png";